import { Reducer } from 'redux';
import { update } from '../helpers/immutabilityHelper'
import * as Dtos from '../dtos/Tmd.dtos';

import {
    ACTION_TRIALINSTITUTIONITEMTEMPLATE_LOAD,
    ACTION_TRIALINSTITUTIONITEMTEMPLATE_LOAD_BY_ID,
    ACTION_TRIALINSTITUTIONITEMTEMPLATE_LOAD_FAILURE,
    ACTION_TRIALINSTITUTIONITEMTEMPLATE_LOAD_SUCCESS,

    ACTION_TRIALINSTITUTIONITEMTEMPLATE_SAVE,
    ACTION_TRIALINSTITUTIONITEMTEMPLATE_SAVE_SUCCESS,
    ACTION_TRIALINSTITUTIONITEMTEMPLATE_SAVE_FAILURE,

    ACTION_TRIALINSTITUTIONITEMTEMPLATE_CREATE,
    ACTION_TRIALINSTITUTIONITEMTEMPLATE_CREATE_SUCCESS,
    ACTION_TRIALINSTITUTIONITEMTEMPLATE_CREATE_FAILURE,

    ACTION_TRIALINSTITUTIONITEMTEMPLATE_VALIDATE,
    ACTION_TRIALINSTITUTIONITEMTEMPLATE_VALIDATE_SUCCESS,
    ACTION_TRIALINSTITUTIONITEMTEMPLATE_VALIDATE_FAILURE,

    ACTION_TRIALINSTITUTIONITEMTEMPLATE_CLEAR,
    ACTION_TRIALINSTITUTIONITEMTEMPLATES_FILTER,

    TrialInstitutionItemTemplateAction
} from '../actions/trialInstitutionItemTemplate';
import { RequestState } from "../enumerations/RequestState";
import { IRequestState, IFormFilter } from "./index";
import { updateFailureIndexToId } from "../helpers/formErrorHelper";

export interface ITrialInstitutionItemTemplateState {
    formData: Dtos.TrialInstitutionItemTemplate | Dtos.TrialInstitutionItemTemplate[],
    formDataTrialed: Dtos.TrialInstitutionItemTemplateCategory[];
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    validationFailures: Dtos.ResponseError[];
    lookups: Dtos.Lookup[],
    loadState: IRequestState;
    saveState: IRequestState;
    updateState: IRequestState;
    createState: IRequestState;
    validateState: IRequestState;
    formFilter: IFormFilter;
    formFilteredData: Dtos.TrialInstitutionItemTemplate[];
    formFilteredDataGrouped: Dtos.TrialInstitutionItemTemplateCategory[];
}

const initialState: ITrialInstitutionItemTemplateState = {
    formData: undefined,
    formDataTrialed: undefined,
    formState: undefined,
    formProperties: undefined,
    validationFailures: undefined,
    lookups: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState,
    saveState: {
        status: RequestState.None
    } as IRequestState,
    updateState: {
        status: RequestState.None
    } as IRequestState,
    createState: {
        status: RequestState.None
    } as IRequestState,
    validateState: {
        status: RequestState.None
    } as IRequestState,
    formFilter: {
        search: "",
        showInActive: false
    },
    formFilteredData: [],
    formFilteredDataGrouped: undefined,
};


function loading(state: ITrialInstitutionItemTemplateState, _isLoading: boolean): ITrialInstitutionItemTemplateState {
    const newState: ITrialInstitutionItemTemplateState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(
    state: ITrialInstitutionItemTemplateState,
    formData: Dtos.TrialInstitutionItemTemplate | Dtos.TrialInstitutionItemTemplate[],
    formDataTrialed: Dtos.TrialInstitutionItemTemplateCategory[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[],
    responseStatus: Dtos.ResponseStatus
): ITrialInstitutionItemTemplateState {
    const newState: ITrialInstitutionItemTemplateState = update(state, {
        formData: {
            $set: formData
        },
        formDataTrialed: {
            $set: formDataTrialed
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return filter(newState, state.formFilter);
}

function filter(state: ITrialInstitutionItemTemplateState, formFilter: IFormFilter): ITrialInstitutionItemTemplateState {

    const formData: Dtos.TrialInstitutionItemTemplate[] | undefined =
        state.formData instanceof Array ?
            state.formData :
            undefined;

    const formFilteredData = formData ? formData.filter(p => (p.active == true || formFilter.showInActive) &&
        (formFilter.search == "" || p.name.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1)) : undefined;

    let formFilteredDataGrouped = [];
    if (state.formDataTrialed) {
        for (var i = 0; i < state.formDataTrialed.length; i++) {
            const filteredTrialInstitutionItemTemplateCategoryItems =
                state.formDataTrialed[i].trialInstitutionItemTemplates.filter(p => (p.active == true || formFilter.showInActive) &&
                    (formFilter.search == "" ||
                        (p.name != undefined && p.name.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1) ||
                        (p.description != undefined && p.description.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1)
                    ));
            if (filteredTrialInstitutionItemTemplateCategoryItems.length > 0) {
                formFilteredDataGrouped.push({
                    ...state.formDataTrialed[i],
                    trialInstitutionItemTemplates: filteredTrialInstitutionItemTemplateCategoryItems
                });
            }
        }
    }

    const newState: ITrialInstitutionItemTemplateState = update(state, {
        formFilter: {
            $set: formFilter
        },
        formFilteredData: {
            $set: formFilteredData
        },
        formFilteredDataGrouped: {
            $set: formFilteredDataGrouped
        }
    });

    return newState;
}

function loadFailure(state: ITrialInstitutionItemTemplateState, responseStatus: Dtos.ResponseStatus): ITrialInstitutionItemTemplateState {
    const newState: ITrialInstitutionItemTemplateState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function clear(state: ITrialInstitutionItemTemplateState, propertiesToClear?: string[]): ITrialInstitutionItemTemplateState {

    if (!propertiesToClear) {
        const newState: ITrialInstitutionItemTemplateState = update(initialState, {});
        return newState;
    }

    let stateModifier: any = {};

    propertiesToClear.forEach(propertyToClear => {
        stateModifier[propertyToClear] = { $set: initialState[propertyToClear] }
    });

    const newState = update(state, stateModifier);

    return newState;
}

function saving(state: ITrialInstitutionItemTemplateState, _isSaving: boolean): ITrialInstitutionItemTemplateState {
    const newState: ITrialInstitutionItemTemplateState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function saveSuccess(
    state: ITrialInstitutionItemTemplateState,
    formData: Dtos.TrialInstitutionItemTemplate | Dtos.TrialInstitutionItemTemplate[],
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): ITrialInstitutionItemTemplateState {
    const newState: ITrialInstitutionItemTemplateState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        saveState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function saveFailure(state: ITrialInstitutionItemTemplateState, responseStatus: Dtos.ResponseStatus): ITrialInstitutionItemTemplateState {
    const newState: ITrialInstitutionItemTemplateState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

function creating(state: ITrialInstitutionItemTemplateState, _isCreating: boolean): ITrialInstitutionItemTemplateState {
    const newState: ITrialInstitutionItemTemplateState = update(state, {
        createState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function createSuccess(
    state: ITrialInstitutionItemTemplateState,
    formData: Dtos.TrialInstitutionItemTemplate,
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
): ITrialInstitutionItemTemplateState {
    const newState: ITrialInstitutionItemTemplateState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        createState: {
            $set: {
                status: RequestState.Success
            } as IRequestState
        }
    });

    return newState;
}

function createFailure(state: ITrialInstitutionItemTemplateState, responseStatus: Dtos.ResponseStatus): ITrialInstitutionItemTemplateState {
    const newState: ITrialInstitutionItemTemplateState = update(state, {
        createState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function validating(state: ITrialInstitutionItemTemplateState, _isValidating: boolean): ITrialInstitutionItemTemplateState {
    const newState: ITrialInstitutionItemTemplateState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function validateSuccess(
    state: ITrialInstitutionItemTemplateState,
    formData: Dtos.TrialInstitutionItemTemplate,
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): ITrialInstitutionItemTemplateState {
    const newState: ITrialInstitutionItemTemplateState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        validateState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function validateFailure(state: ITrialInstitutionItemTemplateState, responseStatus: Dtos.ResponseStatus): ITrialInstitutionItemTemplateState {
    const newState: ITrialInstitutionItemTemplateState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

const TrialInstitutionItemTemplateReducer: Reducer<ITrialInstitutionItemTemplateState> = (state: ITrialInstitutionItemTemplateState = initialState, action: TrialInstitutionItemTemplateAction) => {
    switch (action.type) {
        case ACTION_TRIALINSTITUTIONITEMTEMPLATE_LOAD:
        case ACTION_TRIALINSTITUTIONITEMTEMPLATE_LOAD_BY_ID:
            return loading(state, true);
        case ACTION_TRIALINSTITUTIONITEMTEMPLATE_LOAD_SUCCESS:
            return loadSuccess(state, action.formData, action.formDataTrialed, action.formState, action.formProperties, action.lookups, action.responseStatus);
        case ACTION_TRIALINSTITUTIONITEMTEMPLATE_LOAD_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_TRIALINSTITUTIONITEMTEMPLATE_CLEAR:
            return clear(state, action.propertiesToClear);
        case ACTION_TRIALINSTITUTIONITEMTEMPLATE_SAVE:
            return saving(state, true);
        case ACTION_TRIALINSTITUTIONITEMTEMPLATE_SAVE_SUCCESS:
            return saveSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_TRIALINSTITUTIONITEMTEMPLATE_SAVE_FAILURE:
            return saveFailure(state, action.responseStatus);
        case ACTION_TRIALINSTITUTIONITEMTEMPLATE_CREATE:
            return creating(state, true);
        case ACTION_TRIALINSTITUTIONITEMTEMPLATE_CREATE_SUCCESS:
            return createSuccess(state, action.formData, action.formState, action.formProperties, action.lookups);
        case ACTION_TRIALINSTITUTIONITEMTEMPLATE_CREATE_FAILURE:
            return createFailure(state, action.responseStatus);
        case ACTION_TRIALINSTITUTIONITEMTEMPLATE_VALIDATE:
            return validating(state, true);
        case ACTION_TRIALINSTITUTIONITEMTEMPLATE_VALIDATE_SUCCESS:
            return validateSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_TRIALINSTITUTIONITEMTEMPLATE_VALIDATE_FAILURE:
            return validateFailure(state, action.responseStatus);
        case ACTION_TRIALINSTITUTIONITEMTEMPLATES_FILTER:
            return filter(state, action.formFilter);
    }

    return state;
}

export default TrialInstitutionItemTemplateReducer;